
export const environment = {
  production: false,  
  bpmsBaseUrl: '../webapi/'  
  // bpmsBaseUrl: 'https://dev-bpms-in.loreal-apac.net/webapi' 
};
